export const Footer = () => {
  return (
    <footer
      data-testid="landing-footer"
      className="relative w-full border-t border-slate-200/70 px-4 py-10 text-center sm:px-8"
    >
      <div className="font-display text-lg font-bold tracking-tight text-slate-900">
        Sound<span className="text-sky-600">Ladder</span>
      </div>
      <p className="font-body mt-2 text-xs text-slate-400">
        © {new Date().getFullYear()} The Sound Ladder — Drew’s Sound Ladder Method. All rights reserved.
      </p>
    </footer>
  );
};
